import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { CustomValidatorService } from 'src/app/shared/services/custom-validator.service';
import { CompleteInspectionType } from '../../models/complete-inspection-type.enum';
import { InspectionOfficer } from '../../models/inspectionOfficer';
import { Representatives } from '../../models/representatives.model';
import { InspectionStorageService } from '../../services/inspection-storage.service';
import { InspectionService } from '../../services/inspection.service';

@Component({
  selector: 'app-representative',
  templateUrl: './representative.component.html',
  styleUrls: ['./representative.component.scss'],
})
export class RepresentativeComponent implements OnInit {
  representativeForm: FormGroup;
  inspectionOfficer: InspectionOfficer;
  inspectionOfficers: InspectionOfficer[] = [];
  completeInspectionType: any;
  completeInspectionListByType: InspectionOfficer[] = [];
  nsdaOfficerId: number = 0;
  representativeList: Representatives[] = [];
  contactNumberAlreadyExist = false;

  //#region Constructor
  constructor(
    private fb: FormBuilder,
    private notification: NzNotificationService,
    private customValidatorService: CustomValidatorService,
    private inspectionStorageService: InspectionStorageService,
    private inspectionService: InspectionService
  ) {
    //#region Get type string by using enum
    let type = String(CompleteInspectionType.Representative);
    this.onCompleteInspectionByInspectionType(type);
    //#endregion

    this.inspectionService.representativeList.subscribe(
      (res) => (this.representativeList = res)
    );
  }
  //#endregion

  //#region ngOnInit
  ngOnInit(): void {
    this.formValidation();
  }
  //#endregion

  //#region For form validation
  formValidation() {
    this.representativeForm = this.fb.group({
      nsdaOfficerId: [null],
      name: [
        null,
        [Validators.required],
        Validators.composeAsync([
          this.customValidatorService.noWhitespaceValidator(),
        ]),
      ],
      designation: [
        null
        // [Validators.required],
        // Validators.composeAsync([
        //   this.customValidatorService.noWhitespaceValidator(),
        // ]),
      ],
      email: [
        null,
        [
          Validators.required,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
        ],
      ],
      phone: [
        null,
        [Validators.required, Validators.pattern(/^(?:\01)?(?:\d{11})$/)],
      ],
    });
  }
  //#endregion

  //#region Submit Form
  submitForm(): void {
    this.inspectionOfficer = this.representativeForm.value;
    let type = String(CompleteInspectionType.Representative);
    this.inspectionOfficer.type = type;
    let formOfficerId = this.representativeForm.controls.nsdaOfficerId.value;
    this.nsdaOfficerId = formOfficerId;
    let inputContactNumber = this.representativeForm.controls.phone.value;
    let existingContactNumberFound = this.representativeList.filter(
      (w) => w.phone == inputContactNumber
    ).length;

    let inputEmail = this.representativeForm.controls.email.value;
    let existingEmailFound = this.representativeList.filter(
      (w) => w.email == inputEmail
    ).length;
    //#region To add into grid check existing id
    //#region If dropdown is not selected
    if (!formOfficerId) {
      if (this.representativeList[2].name) {
        this.notification.error('Failed', 'Three rows already added');
      } else {
        if (existingContactNumberFound == 0 && existingEmailFound == 0) {
          this.saveOrUpdateRepresentatives(false);
        } else {
          let message = '';
          let title = '';
          let andNeeded = false;
          if (existingContactNumberFound != 0) {
            message = 'Contact number';
            title = 'Contact number';
            andNeeded = true;
          }
          if (existingEmailFound != 0) {
            message = 'and email';
            title = 'Email';
          }
          message += ' already added!';

          this.notification.error(
            (title += ' exist!'),
            'This representative already added in the list.'
          );
        }
      }
    }
    //#endregion
    else {
      //#region If dropdown is selected
      let existingIdFound = this.representativeList.filter(
        (w) => w.id == formOfficerId
      ).length;

      if (this.representativeList[2].name && existingIdFound == 0) {
        this.notification.error('Failed', 'Three rows already added');
      } else {
        let contactFoundOff = this.representativeList.filter(
          (w) => w.phone === inputContactNumber
        ).length;

        let emailFoundOff = this.representativeList.filter(
          (w) => w.email === inputEmail
        ).length;

        let contactFoundOffId = this.representativeList
          .filter((w) => w.phone === inputContactNumber)
          .map((m) => m.id);

        let emailFoundOffId = this.representativeList
          .filter((w) => w.email === inputEmail)
          .map((m) => m.id);

        if (existingIdFound == 0) {
          this.buildGridArray();
          this.notification.success(
            'Success!',
            'Representative information added into list'
          );
        } else {
          if (
            (contactFoundOff != 0 && contactFoundOffId != formOfficerId) ||
            (emailFoundOff != 0 && emailFoundOffId != formOfficerId)
          ) {
            let message = '';
            let title = '';
            // let andNeeded = false;
            let isContactAdded = false;
            if (contactFoundOff != 0 && contactFoundOffId != formOfficerId) {
              message = 'contact number';
              title = 'Contact number';
              isContactAdded = true;
            }

            if (emailFoundOff != 0 && emailFoundOffId != formOfficerId) {
              if (isContactAdded) {
                message += ' and email';
              } else {
                message = 'email';
                title = 'Email';
              }
            }
            // if (andNeeded) {
            //   message += ' and ';
            // }

            this.notification.error(
              (title += ' exist!'),
              'This ' + message + ' already added in another representative.'
            );
          } else {
            let representative = this.representativeList.filter(
              (w) => w.id == this.nsdaOfficerId
            )[0];

            if (
              representative.name ==
                this.representativeForm.controls.name.value &&
              representative.email ==
                this.representativeForm.controls.email.value &&
              representative.phone ==
                this.representativeForm.controls.phone.value &&
              representative.designation ==
                this.representativeForm.controls.designation.value
            ) {
              this.notification.warning(
                'Warning!',
                'There is nothing to update!'
              );
            } else {
              this.saveOrUpdateRepresentatives(true);
            }
          }
        }
      }
    }
    //#endregion
    this.inspectionService.setRepresentatives(this.representativeList);
  }
  //#endregion

  //#region save or update
  saveOrUpdateRepresentatives(isDataExist: boolean) {
    this.inspectionOfficer = this.representativeForm.value;
    let type = String(CompleteInspectionType.Representative);
    this.inspectionOfficer.type = type;
    this.inspectionOfficer.id = this.inspectionOfficer.nsdaOfficerId;
    this.inspectionStorageService
      .saveInspectionOfficer(this.inspectionOfficer)
      .subscribe({
        next: (response) => {
          this.nsdaOfficerId = response.data.id;
          if (!isDataExist) {
            this.buildGridArray();
            this.notification.success(
              'Success!',
              'Representative information saved and added into list'
            );
          } else {
            this.updateGridArray(this.inspectionOfficer.nsdaOfficerId);
            this.notification.success(
              'Success!',
              'Representative information updated into list'
            );
          }
          this.onCompleteInspectionByInspectionType(type);
        },
        error: (error) => this.notification.error('Failed', error),
      });
  }
  //#endregion

  //#region For import data into grid from modal
  buildGridArray() {
    if (!this.representativeList[0].name) {
      let representatives = {} as Representatives;
      representatives.id = this.nsdaOfficerId;
      representatives.name = this.inspectionOfficer.name;
      representatives.designation = this.inspectionOfficer.designation;
      representatives.phone = this.inspectionOfficer.phone;
      representatives.email = this.inspectionOfficer.email;
      this.representativeList.shift();
      this.representativeList.unshift(representatives);
    } else if (!this.representativeList[1].name) {
      let representatives = {} as Representatives;
      representatives.id = this.nsdaOfficerId;
      representatives.name = this.inspectionOfficer.name;
      representatives.designation = this.inspectionOfficer.designation;
      representatives.phone = this.inspectionOfficer.phone;
      representatives.email = this.inspectionOfficer.email;
      this.representativeList.splice(1, 1);
      this.representativeList.splice(1, 0, representatives);
    } else if (!this.representativeList[2].name) {
      let representatives = {} as Representatives;
      representatives.id = this.nsdaOfficerId;
      representatives.name = this.inspectionOfficer.name;
      representatives.designation = this.inspectionOfficer.designation;
      representatives.phone = this.inspectionOfficer.phone;
      representatives.email = this.inspectionOfficer.email;
      this.representativeList.splice(2, 1);
      this.representativeList.push(representatives);
    }
  }

  updateGridArray(nsdaOfficerId: number) {
    if (this.representativeList[0].id == nsdaOfficerId) {
      let representatives = {} as Representatives;
      representatives.id = this.nsdaOfficerId;
      representatives.name = this.inspectionOfficer.name;
      representatives.designation = this.inspectionOfficer.designation;
      representatives.phone = this.inspectionOfficer.phone;
      representatives.email = this.inspectionOfficer.email;
      this.representativeList.shift();
      this.representativeList.unshift(representatives);
    } else if (this.representativeList[1].id == nsdaOfficerId) {
      let representatives = {} as Representatives;
      representatives.id = this.nsdaOfficerId;
      representatives.name = this.inspectionOfficer.name;
      representatives.designation = this.inspectionOfficer.designation;
      representatives.phone = this.inspectionOfficer.phone;
      representatives.email = this.inspectionOfficer.email;
      this.representativeList.splice(1, 1);
      this.representativeList.splice(1, 0, representatives);
    } else if (this.representativeList[2].id == nsdaOfficerId) {
      let representatives = {} as Representatives;
      representatives.id = this.nsdaOfficerId;
      representatives.name = this.inspectionOfficer.name;
      representatives.designation = this.inspectionOfficer.designation;
      representatives.phone = this.inspectionOfficer.phone;
      representatives.email = this.inspectionOfficer.email;
      this.representativeList.splice(2, 1);
      this.representativeList.push(representatives);
    }
  }
  //#endregion

  //#region Complete inspection by inspection type
  onCompleteInspectionByInspectionType(type: string) {
    this.inspectionStorageService
      .getCompleteInspectionByInspectionType(type)
      .subscribe({
        next: (res) => {
          this.completeInspectionListByType = res.data;
          this.completeInspectionListByType.forEach((item, index) => {
            item.nsdaOfficerId = res.data[index].id;
            item.name = `${item.name} (${item.phone})`;
          });
        },
      });
  }
  //#endregion

  //#region On select Inspector Officer
  onSelectOfficer(id: any): void {
    let name = this.completeInspectionListByType.find(
      (o) => o.nsdaOfficerId === id
    );
    let email = this.completeInspectionListByType.find(
      (o) => o.nsdaOfficerId === id
    );
    let phone = this.completeInspectionListByType.find(
      (o) => o.nsdaOfficerId === id
    );
    let designation = this.completeInspectionListByType.find(
      (o) => o.nsdaOfficerId === id
    );

    if (name && designation && email && phone) {
      this.representativeForm.get('name')?.setValue(name.name);
      this.representativeForm.get('email')?.setValue(email.email);
      this.representativeForm.get('phone')?.setValue(phone.phone);
      this.representativeForm
        .get('designation')
        ?.setValue(designation.designation);
    }
  }
  //#endregion

  //#region check unique contact number
  checkContactNumberIfExist(phone: any): void {
    this.contactNumberAlreadyExist = false;
    setTimeout(() => {
      if (phone.value.length > 10) {
        this.inspectionStorageService
          .checkContactNumberExist(phone.value)
          .subscribe({
            next: (res) => {
              if (res.success == true) {
                this.contactNumberAlreadyExist = false;
              } else {
                this.contactNumberAlreadyExist = true;
                this.representativeForm.controls.phone.setErrors({
                  incorrect: true,
                });
              }
            },
          });
      }
    }, 2000);
  }
  //#endregion

  //#region Reset form
  resetForm(): void {
    this.representativeForm.reset();
    for (const key of Object.keys(this.representativeForm.controls)) {
      this.representativeForm.controls[key].markAsPristine();
      this.representativeForm.controls[key].updateValueAndValidity();
    }
  }
  //#endregion
}
